import Axios, { AxiosError } from 'axios';
import { APP_CONFIG } from '@/common';
import { PrecisePriceConfig } from '@/entities/config';
import {
	TradeInServiceTypeAheadResponse,
	PlateToVinServiceResponseData,
	TradeInServiceVinExtraFieldResponse,
	TradeInServiceVehicleByVinResponse,
	TradeInServiceTypeAheadRequest, TradeInReportRequest,
} from '@/types/tradepending';

const axios = Axios.create({
	baseURL: `${APP_CONFIG.TRADE_PENDING_API}`,
});

export class TradePendingService {
	constructor({ apiKey, ppSSOKey }: PrecisePriceConfig) {
		axios.defaults.headers['X-Api-Key'] = apiKey;
		axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
		if (ppSSOKey !== undefined) {
			axios.defaults.headers['X-Pp-Key'] = ppSSOKey;
		}
		// axios.defaults.withCredentials = true;
	}

	public getVehicleDetails(params: TradeInServiceTypeAheadResponse | string) {
		return axios.get('details', {
			params,
		})
			.then(res => res.data)
			.catch((error: AxiosError) => {
				if (error?.response?.status === 404) {
					return Promise.resolve(error?.response?.data);
				}

				throw error;
			});
	}

	public getSuggestedVehicles(params: TradeInServiceTypeAheadRequest): Promise<TradeInServiceTypeAheadResponse[]> {
		return axios.get('typeahead', {
			params,
		})
			.then(res => res.data)
			.catch((error: AxiosError) => {
				if (error?.response?.status === 404) {
					return Promise.resolve(null);
				}

				throw error;
			});
	}

	public getReport(params: TradeInReportRequest) {
		return axios.get('report', {
			params,
		}).then(res => res.data);
	}

	public vinToVehicleDetails(params: PlateToVinServiceResponseData) {
		return axios.get('vin', {
			params,
		})
			.then(res => res.data)
			.then((result: TradeInServiceVinExtraFieldResponse) => {
				let vehicles: Array<TradeInServiceVehicleByVinResponse> = [];

				if (result.vehicle) {
					vehicles.push(result.vehicle);
				} else {
					vehicles = result.vehicles as Array<TradeInServiceVehicleByVinResponse>;
				}
				return {
					details: vehicles,
				};
			}).catch((error: AxiosError) => {
				if (error?.response?.status === 404) {
					return Promise.resolve(null);
				}
				if (error?.response?.status === 400) {
					return Promise.resolve(error?.response?.data);
				}
				throw error;
			});
	}
}
